import firebase from 'firebase'




const firebaseConfig = {
    apiKey: "AIzaSyDlhR3_y5PGEvKBr1qubIhuBgmVL4samkI",
    authDomain: "slack-80fe5.firebaseapp.com",
    projectId: "slack-80fe5",
    storageBucket: "slack-80fe5.appspot.com",
    messagingSenderId: "496238679733",
    appId: "1:496238679733:web:7a898a0486e663f7c390fc"
  };
  // Initialize Firebase
  const app = firebase.initializeApp(firebaseConfig);

  const auth = firebase.auth()
  const db = app.firestore()
  const provider = new firebase.auth.GoogleAuthProvider()

  export {auth , provider };
  export default db ;

